import { render, staticRenderFns } from "./terms-modal.vue?vue&type=template&id=1359fbc6&scoped=true"
import script from "./terms-modal.vue?vue&type=script&lang=js"
export * from "./terms-modal.vue?vue&type=script&lang=js"
import style0 from "./terms-modal.vue?vue&type=style&index=0&id=1359fbc6&prod&lang=css"
import style1 from "./terms-modal.vue?vue&type=style&index=1&id=1359fbc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1359fbc6",
  null
  
)

export default component.exports